import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-84340c18"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "launch-card-item"
};
const _hoisted_2 = {
  class: "launch-card-item-header"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "launch-card-item-header-text"
};
const _hoisted_5 = {
  class: "launch-card-item-body"
};
const _hoisted_6 = {
  class: "launchpad-card-item-title"
};
const _hoisted_7 = {
  class: "launchpad-card-item-content"
};
const _hoisted_8 = {
  class: "launch-card-item-body-action"
};
import { getRelativeUrl } from '@bfe/by-env';
export default {
  __name: 'ItemBase',
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    infoList: {
      type: Array,
      // label: string, content: string
      required: true,
      default() {
        return [];
      }
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        class: "launch-card-item-header-icon",
        src: _unref(getRelativeUrl)(__props.icon)
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1)]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.infoList, (item, idx) => {
        return _openBlock(), _createElementBlock("div", {
          class: "launch-card-item-body-info",
          key: idx
        }, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.label), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(item.content), 1)]);
      }), 128))]), _createElementVNode("div", _hoisted_8, [_renderSlot(_ctx.$slots, "default")])]);
    };
  }
};